// export const $mobile = 1024;
// export const $smallDesktop = 1200;
// export const $mediumDesktop = 1400;

import Modal from 'bootstrap/js/dist/modal';
import Collapse from 'bootstrap/js/dist/collapse';
import Tooltip from 'bootstrap/js/dist/tooltip';
import Tab from 'bootstrap/js/dist/tab';

import $ from 'jquery';
window.$ = window.jQuery = $;
import 'jquery.easing';

window.bootstrap = window.bootstrap || {};
window.bootstrap.Modal = Modal;
window.bootstrap.Collapse = Collapse;
window.bootstrap.Tooltip = Tooltip;
window.bootstrap.Tab = Tab;

import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';
Swiper.use([Autoplay, EffectFade, Pagination]);

window.Swiper = Swiper;

import { dm_header } from './components/header';
import { dm_nav } from './components/nav';

import { dm_reveal } from './config/scroll_reveal';
import { dm_hash } from './config/hash';

import { dm_a_03_newsletter_signup } from './modules/a-03-newsletter-signup';
import { dm_a_01_explore_sectors } from './modules/a-01-explore-sectors';
import { dm_c_02_testimonials } from './modules/c-02-testimonials';
import { dm_c_03_stats } from './modules/c-03-stats';
import { dm_c_07_related_insights_cards } from './modules/c-07-related-insights-cards';
import { dm_c_08_latest_insights_scrolling } from './modules/c-08-latest-insights-scrolling';
import { dm_c_10_awards_partnerships } from './modules/c-10-awards-partnerships';
import { dm_c_11_people_slider } from './modules/c-11-people-slider';
import { dm_c_12_cards } from './modules/c-12-cards';
import { dm_c_13_cards_carousel } from './modules/c-13-cards-carousel';
import { dm_c_15_tabbed_content } from './modules/c-15-tabbed-content';
import { dm_c_16_profiles_grid_search } from './modules/c-16-profiles-grid-search';
import { dm_c_14_content_with_profile } from './modules/c-14-content-with-profile';
import { dm_c_18_locaton_map_list } from './modules/c-18-location-map-list';
import { dm_c_20_accordion_with_image } from './modules/c-20-accordion-with-image';
import { dm_a_04_timeline } from './modules/a-04-timeline';

import { dm_posts } from './templates/posts';
import { dm_single } from './templates/single';
import { dm_single_person } from './templates/single-person';
import { dm_news_insights } from './templates/news-insights';

window.dm_single_person = dm_single_person;

console.log('>> shawgibbs-init');

jQuery(function ($) {
    "use strict";
    console.log('>> loaded');

    dm_reveal();
    dm_hash();
    dm_nav();
    dm_header();
    dm_a_01_explore_sectors();
    dm_c_02_testimonials();
    dm_c_03_stats();
    dm_c_07_related_insights_cards();
    dm_c_08_latest_insights_scrolling();
    dm_c_10_awards_partnerships();
    dm_c_11_people_slider();
    dm_c_12_cards();
    dm_c_13_cards_carousel();
    dm_c_14_content_with_profile();
    dm_c_15_tabbed_content();
    dm_c_16_profiles_grid_search();
    dm_c_18_locaton_map_list();
    dm_c_20_accordion_with_image();

    dm_posts();
    dm_single();
    dm_news_insights();
});

// outside of DOM ready
dm_a_03_newsletter_signup();
dm_a_04_timeline();
